import FitDivs from './helpers/fitdivs';
import GroupedContent from './helpers/grouped-content';
export default class RichText {
    constructor($el) {
        this.$el = $el;
        this._initExternalLinks();
        this.groupedContent = null;
        if (this.$el.length) {
            this.groupedContent = new GroupedContent($el.get(0), {
                layout: 'tabs',
                intelliparse: false,
            });
            FitDivs('.rte');
        }
    }
    unload() {
        if (this.groupedContent) {
            this.groupedContent.unload();
        }
    }
    /**
     * Open links within an RTE field in a new window if they point to external domains
     *
     * @private
     */
    _initExternalLinks() {
        const anchors = this.$el.find('a[href^="http"]').filter((i, el) => el.href.indexOf(location.hostname) === -1);
        anchors.attr('target', '_blank');
    }
}
